import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { Icon } from '@pella/sash-framework';
import { Image } from '../../';

import styles from './index.module.scss';

const SimpleSlider = ({ slides, className, ...other }) => (
	<Slider
		dots={true}
		arrows={true}
		lazyLoad='ondemand'
		nextArrow={<NextArrow />}
		prevArrow={<PrevArrow />}
		autoplay={true}
		autoplaySpeed={5000}
		className={`${styles.simpleSlider} ${className || ''}`}
		infinite={slides?.length > 1 ? true : false}
		responsive={[
			{
				breakpoint: 790,
				settings: { arrows: false },
			},
		]}
		{...other}
	>
		{slides.map((img, index) => (
			<Image
				key={index}
				data={img}
			/>
		))}
	</Slider>
);

SimpleSlider.propTypes = {
	slides: PropTypes.array,
	className: PropTypes.string,
};

const NextArrow = (props) => (
	<button
		className={props.className}
		style={props.style}
		onClick={props.onClick}
		aria-label='Next'
	>
		<span className={styles.srOnly}>Previous</span>
		<Icon
			name='keyboard_arrow_right'
			className='simpleSlider_Arrow'
		/>
	</button>
);

NextArrow.propTypes = {
	className: PropTypes.string,
	style: PropTypes.object,
	onClick: PropTypes.func,
};

const PrevArrow = (props) => (
	<button
		className={props.className}
		style={props.style}
		onClick={props.onClick}
		aria-label='Previous'
	>
		<span className={styles.srOnly}>Next</span>
		<Icon
			name='keyboard_arrow_left'
			className='simpleSlider_Arrow'
		/>
	</button>
);

PrevArrow.propTypes = {
	className: PropTypes.string,
	style: PropTypes.object,
	onClick: PropTypes.func,
};

export default SimpleSlider;
